import { DateEvent } from "../types/date";
import { DateTime, createEvent } from "ics";
import dayjs from "dayjs";
import { useTranslation } from "~/primitives/translator";
import { snake } from "~/util/helpers";
import { downloadBlob } from "~/util/download";

export const addEventToCalendar = async (event: DateEvent) => {

	const startDay = dayjs(event.startTime);
	const endDay = event.endTime ? dayjs(event.endTime) : startDay;

	const [title, categoryTitle, content] = await Promise.all([
		useTranslation(event.title),
		useTranslation(event.category.title),
		event.content ? useTranslation(event.content) : undefined
	]);

	const createDateTuple = (day: dayjs.Dayjs) => [
		day.year(),
		day.month() + 1,
		day.date(),
		day.hour(),
		day.minute()
	] as DateTime;

	createEvent({
		end: createDateTuple(endDay),
		start: createDateTuple(startDay),
		title,
		description: content,
		categories: [categoryTitle]
	}, (error, value) => {

		if (error) {
			console.log(error);
			return;
		}

		const blob = new Blob([value], { type: "text/calendar;charset=utf-8" });
		const file = snake(title) + ".ics";

		downloadBlob(blob, file);
	});
};